import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics, isSupported, logEvent as fbLogEvent, Analytics } from 'firebase/analytics';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBfl0LsUGs8PmWjps1734Y_4ZpF1k_bN2Y",
  authDomain: "tbx-mobile.firebaseapp.com",
  projectId: "tbx-mobile",
  storageBucket: "tbx-mobile.firebasestorage.app",
  messagingSenderId: "509313689570",
  appId: "1:509313689570:web:465376e72f9175bc55fbbb",
  measurementId: "G-Y0H87F2QEL"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Global analytics reference
let analyticsInstance: Analytics | null = null;

// Initialize Analytics with fallback and error handling
export const initializeAnalytics = async (): Promise<Analytics | null> => {
  // Don't re-initialize if we already have an instance
  if (analyticsInstance) return analyticsInstance;
  
  try {
    // Check if analytics is supported in this environment
    const supported = await isSupported();
    
    if (supported) {
      analyticsInstance = getAnalytics(app);
      console.log('Google Analytics initialized successfully');
      return analyticsInstance;
    } else {
      console.log('Google Analytics is not supported in this environment');
      return null;
    }
  } catch (error) {
    console.error('Failed to initialize Google Analytics:', error);
    return null;
  }
};

// Safe wrapper for logEvent that handles missing analytics gracefully
export const logEvent = async (eventName: string, eventParams: Record<string, any> = {}): Promise<boolean> => {
  try {
    const analytics = await initializeAnalytics();
    if (analytics) {
      fbLogEvent(analytics, eventName, eventParams);
      return true;
    }
    return false;
  } catch (error) {
    console.error(`Error logging event "${eventName}":`, error);
    return false;
  }
};

// Initialize analytics on import
initializeAnalytics().catch(console.error);

export default app; 